import { Database, FileText } from 'lucide-react';

import { useUnauthorizedRedirect } from '@/react/hooks/useUnauthorizedRedirect';

import { PageHeader } from '@@/PageHeader';
import { WidgetTabs, Tab, useCurrentTabIndex } from '@@/Widget/WidgetTabs';

import { CustomResourcesDatatable } from './CustomResourcesDatatable/CustomResourcesDatatable';
import { CustomResourceDefinitionsDatatable } from './CustomResourceDefinitionsDatatable/CustomResourceDefinitionsDatatable';

export function CustomResourcesView() {
  useUnauthorizedRedirect(
    { authorizations: ['K8sApplicationsR'] },
    { to: 'kubernetes.dashboard' }
  );

  const tabs: Tab[] = [
    {
      name: 'Resources',
      icon: Database,
      widget: <CustomResourcesDatatable />,
      selectedTabParam: 'resources',
    },
    {
      name: 'Definitions',
      icon: FileText,
      widget: <CustomResourceDefinitionsDatatable />,
      selectedTabParam: 'definitions',
    },
  ];

  const currentTabIndex = useCurrentTabIndex(tabs);

  return (
    <>
      <PageHeader
        title="Custom Resources"
        breadcrumbs="Custom Resources"
        reload
      />
      <>
        <WidgetTabs tabs={tabs} currentTabIndex={currentTabIndex} />
        <div className="content">{tabs[currentTabIndex].widget}</div>
      </>
    </>
  );
}
